import H2 from "../../../Components/H2";

export const QipCtaCards = ({ title, cards, links }) => {
  return (
    <div>
      {title && (
        <H2 className="text-4xl md:mb-14">
          {title}
        </H2>
      )}

      {cards && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mb-10 md:mb-16">
          {cards.map((column, i) => (
            <div
              key={i}
              className={`flex flex-col sm:flex-row gap-8 justify-between items-center p-10 rounded-2xl ${i % 2 !== 0 ? "border border-solid border-gray" : "bg-light-gray"}`}
            >
              {column.featured_image && (
                <img
                  src={column.featured_image.sizes.large}
                  alt=""
                  className="mb-0 max-w-40"
                />
              )}
              <div className="basis-full">
                <h3 className="text-xl mb-4">{column.title}</h3>
                <div
                  className="text-base [&_p]:text-base mb-6"
                  dangerouslySetInnerHTML={{ __html: column.copy }}
                />
                {column.cta && (
                  <a
                    href={column.cta.url}
                    className={`px-4 py-3 block text-lg text-center ${i % 2 === 0 ? "text-white bg-error hover:bg-black" : "text-jay-blue bg-white border border-solid border-jay-blue hover:bg-black hover:text-white"}`}
                  >
                    {column.cta.title}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {links && (
        <div className="border-y border-solid border-gray py-4">
          {links.map((column, i) => (
            <div key={i} className="text-left">
              <a
                href={column.link.url}
                className={`text-black text-base block ${links.length - 1 !== i ? "mb-4" : "mb-0"}`}
              >
                {column.link.title}
              </a>
              {links.length - 1 !== i && (
                <hr className="border-t border-solid border-gray mb-4" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
